import { useContext } from 'react';
import type * as React from 'react';
import { CardContext } from '../../utils/cardContext';
import { Gallery as GalleryComponent } from '../../components/Gallery';

export const Gallery = (): React.JSX.Element => {
  const layout = useContext(CardContext);

  return <GalleryComponent images={layout.images} url={layout.url} />;
};
